import axios from "axios";
import { useMutation } from "react-query";
import { Status } from "../../../components/FacilityManager/Domain/Types/Status";

interface RequestBody {
  caseDTO: Partial<any> & {
    bookingInventoryIds: (number | undefined)[] | undefined;
    startDate: string | null;
    endDate: string | null;
    startTime: string | null;
    endTime: string | null;
  };
}

export function useRemoteMutateGetBookingStatusInformation() {
  return useMutation({
    mutationFn: async (params: RequestBody) => {
      const response = await axios.get<Status>("booking/status-information", {
        params: params.caseDTO
      });
      return response.data;
    }
  });
}
